import React from 'react';

const DistributionButtons = ({campaignId}) => {
    return (
        <div className="snclient_campaign-distribution-buttons">
            <div className="facebook-controls">
                <a
                    className="btn btn-facebook"
                    href={`/distributions?campaign_id=${campaignId}&distribution_type=facebook_paid`}
                >
                    <div className="facebook-logo-icon cta-button-icon" />
                    <span className="facebook-button-text facebook-ad-text">
                        Upload to Facebook Business Account
                    </span>
                </a>
            </div>
        </div>
    );
};

export default DistributionButtons;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/distribution_buttons/index.js